import { gql } from "@apollo/client";

export const GET_SELLER_TRANSACTIONS = gql`
  query SellerTransactions(
    $pageSize: Int!
    $currentPage: Int!
    $filter: SellerTransactionFilterInput
  ) {
    sellerTransactions(
      pageSize: $pageSize
      currentPage: $currentPage
      filter: $filter
    ) {
      items {
        bank_transaction_id
        date_of_transaction
        entity_transaction_id
        message
        transaction_amount
        transaction_id
        type
         sales_data
            {
                total_amount
                total_commission
            }
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      total_count
      order_totals {
            total_sales
            total_commission
            total_earnings
            total_withdrawal
            total_payment
      }
    }
  }
`;
